import { Cart } from '../interfaces/cart';

export const mergeCartProducts = (selectedCart: Cart) => [
  ...(selectedCart?.items ?? []),
  ...(selectedCart?.freeItems ?? []),
  ...(selectedCart?.redeemableItems ?? []),
  ...(selectedCart?.returnItems ?? [])
];
